module.exports = __webpack_public_path__ + "img/winerackdog23.579b1a13.jpg";